import { config } from '../config'
import { createServiceFetch } from './validateFetchUrl'

const tagpApiFetch = createServiceFetch(config.api.baseUrl)
const { auth: authConfig, api: apiConfig } = config

/**
 * OAuth refresh for long AIServices runs (Azure AD). Prefer localStorage; if absent
 * (Azure cookie/session flow — refresh not in redirect URL), load from TAGP Redis session
 * via `GET /api/v1/auth/session/run-as-refresh-token` (same as AI Workflows run-as).
 *
 * Must use `/v1/` — auth routes live under the versioned router, not `/api/auth/...`.
 */
export async function resolveOAuthRefreshTokenForLongRuns(): Promise<string | null> {
  try {
    const r = localStorage.getItem(authConfig.refreshTokenKey)
    if (r?.trim()) return r.trim()
  } catch {
    /* ignore */
  }
  let accessToken: string | null = null
  try {
    accessToken = localStorage.getItem(authConfig.tokenKey)
  } catch {
    return null
  }
  if (!accessToken?.trim()) return null

  let tenantId: string | null = null
  try {
    tenantId = localStorage.getItem('tagp-tenant-id')
  } catch {
    /* ignore */
  }

  const url = `${apiConfig.baseUrl}/v1/auth/session/run-as-refresh-token`
  try {
    const res = await tagpApiFetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken.trim()}`,
        ...(tenantId?.trim() ? { 'X-Tenant-ID': tenantId.trim() } : {}),
      },
      credentials: 'include',
    })
    if (!res.ok) return null
    const data = (await res.json()) as { refresh_token?: string }
    const rt = data?.refresh_token
    const out = typeof rt === 'string' && rt.trim() ? rt.trim() : null
    if (out) {
      try {
        localStorage.setItem(authConfig.refreshTokenKey, out)
      } catch {
        /* still return out for this request */
      }
    }
    return out
  } catch {
    return null
  }
}
